/**
 * Adapted from https://github.com/kat-ya/stylis-class-specificity-plugin
 */
import { StylisPlugin } from "styled-components";

// https://www.npmjs.com/package/stylis/v/3.5.0#Plugins
export const STYLIS_CONTEXTS = {
  POST_PROCESS: -2,
  PREPARATION: -1,
  NEWLINE: 0,
  PROPERTY: 1,
  SELECTOR_BLOCK: 2,
  AT_RULE: 3,
};

export function createExtraSpecificityPlugin(repeatTimes = 1) {
  const plugin: StylisPlugin = (context, _content, selectors) => {
    if (context === STYLIS_CONTEXTS.SELECTOR_BLOCK) {
      for (let i = 0; i < selectors.length; i++) {
        const selector = selectors[i];
        if (/^\.[\w\d-_]+$/i.test(selector) && repeatTimes > 1) {
          selectors[i] = selector.repeat(repeatTimes);
        }
      }
    }
  };

  Object.defineProperty(plugin, "name", {
    value: "createExtraSpecificityPlugin",
  });

  return plugin;
}
